import React from 'react';

import IconDailyShow from '@components/Images/IconDailyShow';
import IconTITV from '@components/Images/IconTITV';

const TITVDailyShow = () => {
  return (
    <div className="align-center flex justify-start gap-24 text-primary-magenta">
      <IconTITV height={60} aria-label="TITV" />
      <IconDailyShow width={250} aria-label="Daily Show" />
    </div>
  );
};

export default TITVDailyShow;
